import { gql } from '@apollo/client'

export const GET_INVENTORIES = gql`
  query GetInventories($limit: Int!, $page: Int!, $input: InventoriesQueryInput) {
    inventories(pagination: { size: $limit, page: $page }, input: $input) {
      total
      items {
        id
        name
        company {
          id
          name
        }
        type
        address {
          city {
            id
            name
          }
        }
        users {
          id
          firstName
          lastName
          username
        }
      }
    }
  }
`
